import { render, staticRenderFns } from "./AdminBasic.vue?vue&type=template&id=2a8d5b56"
import script from "./AdminBasic.vue?vue&type=script&lang=js"
export * from "./AdminBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports